// extracted by mini-css-extract-plugin
module.exports = {"ActionColumn":"Actions__ActionColumn__3PHHZ","Title":"Actions__Title__3Y79-"};